var _rect, _circle, _circle2, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBinocularWoman = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5.25172,
    fill: "#F4EFFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1856,
    cy: 40.1856,
    r: 25.7857,
    fill: "#B7C2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5013_214989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 52,
    height: 52
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1856,
    cy: 40.1856,
    r: 25.7857,
    fill: "#B7C2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5013_214989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3289 60.9459C14.2162 57.2549 18.9151 51.8539 25.0011 51.8539C28.4545 51.8539 31.8324 51.8539 33.1723 48.0227C34.2196 45.0045 35.4651 39.9492 35.4651 33.4642C35.4651 29.8199 31.9079 26.3999 27.9921 26.3999C23.029 26.3999 20.17 29.5116 19.4435 33.1091C18.717 36.7067 15.5089 39.4633 12.848 39.4633C9.88524 39.4633 7.649 42.0423 7.649 44.9764C7.649 47.9106 6.26197 49.5271 3.41242 49.5271C0.562874 49.5271 -2.3999 52.508 -2.3999 57.3016C-2.3999 62.0953 0.0816588 65.6928 3.77098 65.6928C7.46029 65.6928 8.82845 64.1323 11.3289 60.9459Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5448 43.2922C25.5448 43.2922 26.1335 46.7706 29.7001 46.7706C33.2668 46.7706 32.8988 43.416 33.1253 41.0612C33.3517 38.7064 34.1254 31.7859 34.1254 31.7859C34.1254 31.7859 33.7952 32.4867 33.4555 32.4867C33.1253 32.4867 32.7856 31.7859 32.7856 31.7859C32.7856 31.7859 32.7384 32.739 32.3327 32.739C31.9269 32.739 31.5306 32.0849 31.5306 32.0849C31.5306 32.0849 31.2193 33.0474 30.6626 33.0474C30.1059 33.0474 29.9172 31.7952 29.9172 31.7952C29.9172 31.7952 29.8039 33.3838 28.917 33.3838C28.0206 33.3838 27.9451 32.0569 27.9451 32.0569C27.9451 32.0569 27.9829 33.4211 27.1997 33.4211C26.4165 33.4211 26.124 32.0195 26.124 32.0195L26.3599 32.6923L21.5667 53.3023L26.7562 55.7318L29.1717 54.4049L29.6907 53.6667L28.9264 46.7145C28.9264 46.7145 25.4033 46.6095 25.5448 43.2922Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8799 35.819C22.8799 35.819 20.8418 35.4078 20.8418 37.0244C20.8418 38.6036 22.5591 38.3232 22.5591 38.3232L22.8799 35.819Z",
    fill: "#C693AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2837 38.9494L23.7649 35.2117",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5492 38.8402C22.5492 38.8402 23.6265 39.694 23.0527 40.9932C22.4789 42.2925 21.5101 42.1507 20.8972 41.88C20.2844 41.6094 19.7934 40.7592 20.2578 39.7078C20.7183 38.665 21.4909 38.6766 21.4909 38.6766",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0676 47.9854L28.926 46.7145C28.926 46.7145 25.4031 46.6095 25.5447 43.2922C25.5541 43.2922 24.897 47.2565 29.0676 47.9854Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8169 49.032C50.8169 47.5462 53.1664 46.8828 55.7328 46.8828C57.4029 46.8828 59.4788 45.9764 59.4788 49.032C59.4788 51.4148 57.8747 51.7138 55.2044 51.7138C52.2983 51.7138 50.8169 50.5084 50.8169 49.032Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7038 51.3119V35.7722L50.5808 32.2961C50.5808 32.2961 49.7221 30.5861 51.0997 29.904C52.4773 29.2219 56.0629 27.9791 57.4876 31.1281C58.9124 34.2771 58.686 49.9196 58.686 49.9196L54.5154 53.8255L52.7038 51.3119Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4308 29.147C52.7043 29.2218 52.5911 29.5582 52.5911 29.9787C52.5911 30.7636 53.7516 30.829 53.8932 31.941L55.7426 31.7074C55.4784 30.8197 53.846 30.4365 53.8177 29.7731C53.8083 29.4834 53.9687 29.0723 54.7046 29.0909",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1848 29.4648C51.4394 29.6611 51.2695 30.0348 51.2695 30.4553C51.2695 31.2403 52.4301 31.3057 52.5716 32.4177",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.911 39.2859L36.1351 38.1179C36.1351 38.1179 35.1443 37.9403 35.0028 36.52C34.8613 35.109 35.918 34.8941 35.918 34.8941L49.4581 33.3242L49.911 39.2859Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3466 40.949L44.7028 39.6689C44.7028 39.6689 42.5609 39.183 42.476 36.5385C42.3911 33.81 44.2404 33.1745 44.2404 33.1745L57.6201 31.4739L58.3466 40.949Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0249 35.5574C55.0249 37.6598 55.9968 40.949 58.3462 40.949C60.6957 40.949 60.7523 38.0056 60.7523 35.9872C60.7523 33.9688 59.2992 31.4739 57.6197 31.4739C55.9402 31.4739 55.0249 34.3146 55.0249 35.5574Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8839 34.436C57.3744 34.436 57.214 35.1462 57.3084 36.2115C57.3933 37.23 57.6952 37.6785 58.2142 37.6785C58.7331 37.6785 58.7426 36.7347 58.6671 35.9779C58.5822 35.2116 58.4689 34.436 57.8839 34.436Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2591 39.9213L29.6623 38.6785C29.6623 38.6785 28.6055 38.4823 28.4639 36.9872C28.3224 35.4921 29.4264 35.2585 29.4264 35.2585L43.7685 33.5952L44.2591 39.9213Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1947 41.678L38.7394 40.323C38.7394 40.323 36.4748 39.8091 36.3805 37.0058C36.2861 34.1184 38.2487 33.4456 38.2487 33.4456L52.421 31.6328L53.1947 41.678Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.675 35.9686C49.675 38.1925 50.7035 41.678 53.1945 41.678C55.6855 41.678 55.7421 38.557 55.7421 36.4171C55.7421 34.2773 54.2041 31.6328 52.4208 31.6328C50.6375 31.6328 49.675 34.6417 49.675 35.9686Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7039 34.7817C52.1661 34.7817 51.9963 35.5386 52.0906 36.66C52.185 37.7439 52.4964 38.2111 53.0531 38.2111C53.6098 38.2111 53.6098 37.2113 53.5248 36.4077C53.4399 35.604 53.3173 34.7817 52.7039 34.7817Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0137 48.0977L41.5793 48.2845L40.532 48.7331V51.9569L48.3258 53.0688L44.0137 48.0977Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3257 53.8256C48.3257 53.8256 48.3257 49.2282 48.3257 47.9574C48.3257 45.6774 48.9485 41.949 48.0993 41.2949C46.6084 40.1548 46.3442 39.0803 46.3442 37.0619C46.3442 33.9222 47.5803 32.5953 48.8258 32.1C49.4674 31.8477 49.3164 30.6703 48.0615 30.9413C46.8066 31.2123 44.2967 33.1092 44.2967 37.1834C44.2967 37.1834 44.1174 32.3243 48.0615 30.9413C48.0615 30.9413 47.1934 30.063 46.1933 30.7731C45.1931 31.4833 42.2964 32.7915 42.2964 37.174C42.2964 37.174 41.7963 33.1279 46.1933 30.7731C46.1933 30.7731 45.6366 30.119 44.4194 30.7731C43.2022 31.4272 40.3904 33.4176 40.3904 37.9496C40.3904 42.4816 41.768 42.2573 41.768 43.9954C41.768 45.7334 41.768 53.265 41.768 53.265L48.3257 53.8256Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6697 95.4452L35.8517 95.0808L34.4458 63.226L33.4362 53.6854L29.4638 51.4988C29.4638 51.4988 29.7091 54.0031 27.3125 54.0031C25.0857 54.0031 23.2929 53.2836 22.0946 51.1531L19.6791 55.1618V95.4452H19.6697Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.878 51.125C20.0475 51.125 11.3667 54.218 10.6213 60.9646C9.85705 67.8607 7.02637 93.1932 6.50741 96.0245C5.98846 98.8559 6.33757 99.8837 8.4134 100.482C10.4892 101.08 19.0568 103.136 20.4438 103.481C21.8308 103.827 24.7747 103.481 24.8596 100.314C24.9446 97.1459 24.5294 60.9739 24.5105 58.6565C24.4822 54.9188 23.2178 51.125 21.878 51.125Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.748 99.0429C33.7952 99.9399 33.3989 100.921 35.2199 100.454C37.0316 99.9866 42.3061 97.8001 42.9477 97.501C43.5893 97.202 43.4195 96.903 43.3817 96.1274C43.3345 95.3612 37.192 63.5531 37.192 63.5531L39.5603 75.8783C39.5603 75.8783 48.5241 81.2326 51.034 82.7744C53.5439 84.3162 60.8093 84.9796 60.5168 79.3263C60.2242 73.673 59.4788 49.032 59.4788 49.032C59.4788 49.032 57.5445 50.2467 54.8837 50.2467C52.2229 50.2467 50.817 49.032 50.817 49.032L51.6756 70.7482C51.6756 70.7482 36.9844 55.3394 35.4558 53.7228C33.9273 52.1063 30.4172 50.7233 29.3699 50.7233C32.4176 54.4237 33.748 99.0429 33.748 99.0429Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5278 69.5334C16.5278 69.5334 37.7768 86.6429 39.947 87.9511C42.1172 89.2593 48.3918 90.4834 48.3163 84.6525C48.2409 78.8217 48.3163 51.1531 48.3163 51.1531C48.3163 51.1531 46.7029 52.0501 43.5136 51.6483C41.0038 51.3306 38.9751 48.3311 41.768 48.3311C41.768 48.3311 39.947 47.9853 39.947 50.798C39.947 54.9002 39.947 79.4104 39.947 79.4104V77.1303L21.7835 58.3202",
    fill: "#AE90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5278 69.5334C16.5278 69.5334 37.7768 86.6429 39.947 87.9511C42.1172 89.2593 48.3918 90.4834 48.3163 84.6525C48.2409 78.8217 48.3163 51.1531 48.3163 51.1531C48.3163 51.1531 46.7029 52.0501 43.5136 51.6483C41.0038 51.3306 38.9751 48.3311 41.768 48.3311C41.768 48.3311 39.947 47.9853 39.947 50.798C39.947 54.9002 39.947 79.4104 39.947 79.4104V77.1303L21.7835 58.3202",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2599 25.7879C50.2596 25.7878 50.2593 25.7876 50.2589 25.7874C50.2665 25.7905 50.2672 25.7914 50.2599 25.7879ZM50.638 24.568C50.4757 24.1039 50.21 23.7236 49.8922 23.4814C49.616 23.2709 49.0915 23.0337 48.6076 23.3556C48.4287 23.4745 48.2916 23.6433 48.2186 23.8565C48.152 24.0513 48.153 24.2427 48.1692 24.3969C48.1992 24.6817 48.3072 25.0319 48.4178 25.3902L48.4227 25.406C48.589 25.9522 48.9463 26.3711 49.2452 26.6291C49.3955 26.7589 49.5558 26.8695 49.7045 26.9411C49.7686 26.972 49.883 27.0218 50.0185 27.036C50.0826 27.0427 50.2248 27.0501 50.3813 26.9787C50.5788 26.8886 50.7225 26.7066 50.7599 26.4861C50.7607 26.4813 50.7617 26.4754 50.7629 26.4685C50.7941 26.2901 50.9429 25.4393 50.638 24.568Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5021 26.3974L54.5036 26.3973C54.6984 26.3807 54.8466 26.295 54.9371 26.2291C55.0321 26.1599 55.1094 26.0789 55.1695 26.0066C55.2899 25.8617 55.3934 25.6879 55.4757 25.5237C55.5598 25.3561 55.6337 25.1748 55.6878 25.0025C55.7382 24.8419 55.7865 24.6426 55.7865 24.4533C55.7865 24.4405 55.7866 24.4256 55.7867 24.409C55.7879 24.2288 55.7906 23.8372 55.6829 23.4866C55.6213 23.2857 55.5077 23.0398 55.2861 22.8467C55.0484 22.6396 54.7465 22.5455 54.4178 22.5618L54.4494 23.201L54.4188 22.5617C54.0167 22.5809 53.6399 22.7378 53.3932 23.0948C53.1761 23.4091 53.1247 23.7903 53.1202 24.121C53.1147 24.525 53.2451 25.0271 53.3999 25.4095C53.479 25.6049 53.5805 25.8095 53.7035 25.9761C53.7643 26.0584 53.8485 26.1564 53.9593 26.2372C54.0676 26.3162 54.2567 26.4177 54.5021 26.3974Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8808 27.0348L58.8808 27.0349L58.8905 27.0336C59.1635 26.9962 59.3763 26.8493 59.5138 26.732C59.6606 26.6068 59.789 26.4568 59.8946 26.3177C60.1056 26.0395 60.2809 25.7297 60.3787 25.5515C60.538 25.2649 60.6227 24.8571 60.6375 24.5184C60.6453 24.3411 60.6363 24.1383 60.5868 23.9461C60.5421 23.7724 60.4326 23.4863 60.1443 23.3158C59.8023 23.1137 59.4634 23.2154 59.2708 23.3198C59.0845 23.4207 58.9324 23.5713 58.8209 23.6987C58.5903 23.9621 58.3821 24.3041 58.2399 24.5687C58.0348 24.9504 57.9701 25.463 57.9734 25.8374C57.9751 26.0299 57.9949 26.2452 58.053 26.4324C58.0806 26.5213 58.1325 26.6565 58.2369 26.7785C58.3541 26.9156 58.5768 27.0717 58.8808 27.0348Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.222 28.5877C64.9807 32.074 65.9713 36.0141 65.9713 40.1856C65.9713 54.4266 54.4266 65.9713 40.1856 65.9713C25.9445 65.9713 14.3999 54.4266 14.3999 40.1856C14.3999 25.9445 25.9445 14.3999 40.1856 14.3999C45.694 14.3999 50.799 16.1271 54.9886 19.0696",
    stroke: "#040222",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBinocularWoman);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/binocular-woman.a67da032a75fa62842ab87be0f2791ff.svg";